import axios from "axios";
import { useSetRecoilState } from "recoil";
import { authAtom, storage } from "stores";
import { StackActions, useNavigation } from "@react-navigation/native";
import { colors } from "assets/constants";

export default function useEject() {
  const setAuth = useSetRecoilState(authAtom);
  const navigation = useNavigation();

  const eject = () => {
    delete axios.defaults.headers.common.Authorization;
    setAuth({ company: { color: colors.theme } });
    storage.set(null);
    navigation?.dispatch(StackActions.replace("insert_mobile"));
  };

  return eject;
}
